module.exports = __webpack_public_path__ + "389e50e641f670a1288915e48dc0ceca.svg";